import * as React from 'react';
import { useState } from 'react';
import { Button, Checkbox, FormControlLabel, TextField, Typography, Snackbar } from '@mui/material';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';

export default function ARSSecurityPage({ onSubmit, loading, accountName }) {  // Added accountName prop
  const [passphrase, setPassphrase] = useState('');
  const [id, setId] = useState('');
  const [hasAgreed, setHasAgreed] = useState(false);
  const [open, setOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');

  const handleSubmit = () => {
    if (loading) {
      if (passphrase.trim() === '' || id.trim() === '') {
        setAlertMsg('Passphrase and ID are required.');
        setOpen(true);
        return;
      }
    } else {
      // Handle the case when isLoading is false
      if (id.trim() === '') {
        setAlertMsg('ID is required.');
        setOpen(true);
        return;
      }
    }

    if (!hasAgreed) {
      setAlertMsg('You must agree to the terms to proceed.');
      setOpen(true);
      return;
    }

    if (onSubmit) {
      onSubmit({ passphrase, id, hasAgreed });  // Passing the values as an object to the callback
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Container component="main" maxWidth="sm">
      <Paper elevation={8} style={{  marginTop: '20px',paddingTop: '20px', paddingBottom: '20px' }}>
       
        
        <Typography variant="h5" align="center">
          ARS Security Check
        </Typography>
        {accountName && (
          <Typography 
            variant="h6" 
            align="center" 
            style={{ 
              margin: '15px',
              fontWeight: 'bold',
              color: '#000',
              borderBottom: '1px solid #e0e0e0',
              paddingBottom: '10px'
            }}
          >
            {accountName}
          </Typography>
        )}
        <form noValidate autoComplete="off" style={{ margin: '20px' }}>
          {loading?<TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="passphrase"
            label="Passphrase"
            name="passphrase"
            autoFocus
            value={passphrase}
            onChange={(e) => setPassphrase(e.target.value)}
          />:null}



          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="id"
            label="ID"
            name="id"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />

          <FormControlLabel
            control={
              <Checkbox
                value="allowExtraEmails"
                color="primary"
                checked={hasAgreed}
                onChange={(e) => setHasAgreed(e.target.checked)}
              />
            }
            label={
              <div style={{
                border: '2px solid #D32F2F',
                borderRadius: '5px',
                padding: '10px',
                backgroundColor: '#ffebee',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                margin: '10px 0'
              }}>
                <Typography variant="body2" style={{
                  fontWeight: 'bold'
                }}>
                  Under penalty of law, I confirm that I am authorized to use this system.
                </Typography>
              </div>
            }
          />
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            style={{ margin: '20px 0' }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </form>

        {/* <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: '20px' }}>
          Under penalty of law I am confirming that I have authorization to use this system
        </Typography> */}
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleClose} severity="warning">
            {alertMsg}
          </Alert>
        </Snackbar>
      </Paper>
    </Container>
  );
}
